import React from 'react';

const MailIcon = (props) => (
  <svg role='presentation' width='32' height='32' viewBox='0 0 32 28' {...props}>
    <g fill='currentColor'>
      <path d='M12.968 16.468l.91.91c1.125 1.125 2.921 1.17 4.1.136l.143-.135.91-.91 4.915 5.294c-.282.151-.604.237-.946.237H9c-.343 0-.665-.086-.947-.238l4.915-5.294zm-5.61-5.61l4.549 4.549-4.817 5.189C7.032 20.408 7 20.208 7 20v-8c0-.425.132-.818.358-1.142zM25 12v8c0 .208-.032.408-.09.596l-4.818-5.189 4.55-4.549c.226.324.358.717.358 1.142zm-2.356-2l-5.936 5.965-.094.083c-.323.252-.765.279-1.113.078l-.113-.075-.097-.086L9.344 10h13.3z' />
    </g>
  </svg>
);

export default MailIcon;
